import * as React from 'react';
import { useEffect, useState } from 'react';

import CircleSpinner from '@core/components/display/spinners/CircleSpinner';
import { classNames } from '@core/utils/functions/class-names';

import NewsCategoryTabs, { NewsCategoryTab } from '@/components/pages/frontpage/components/News/NewsCategoryTabs';
import NewsSectionArticle from '@/components/pages/frontpage/components/News/NewsSectionArticle';
import type { ArticleType } from '@/types/ArticleType';
import fetchPostsByCategory from '@/utils/functions/wordpress/fetchPostsByCategory';

type NewsSectionProps = {
    className?: string;
    articles: ArticleType[];
    categoryTabs: NewsCategoryTab[];
    onCategoryChange?: (category: NewsCategoryTab) => void;
};

const NewsSection = (props: NewsSectionProps) => {
    const { className, categoryTabs, onCategoryChange } = props;
    const [selectedCategorySlug, setSelectedCategorySlug] = useState<string | null>('markets');
    const [articles, setArticles] = useState<ArticleType[]>(props.articles.slice(5, 11));
    const [isLoadingArticles, setIsLoadingArticles] = useState(false);

    useEffect(() => {
        if (selectedCategorySlug === null) {
            return;
        }

        setIsLoadingArticles(true);
        fetchPostsByCategory(selectedCategorySlug, 6).then(result => {
            setArticles(result);
            setIsLoadingArticles(false);
        });
    }, [selectedCategorySlug]);

    return (
        <div
            className={classNames(
                'flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-5 px-10 pb-5 w-full',
                className
            )}
        >
            <div>
                <NewsCategoryTabs
                    tabs={categoryTabs}
                    onClickTab={tab => {
                        setSelectedCategorySlug(tab.slug);
                        onCategoryChange && onCategoryChange(tab);
                    }}
                />
            </div>
            {!isLoadingArticles && (
                <div className="mt-0 md:mt-6 lg:mt-12 grid gap-8 grid-cols-1 xs:grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
                    {articles.map(article => (
                        <NewsSectionArticle article={article} key={`NewsSectionArticle-${article.slug}`} />
                    ))}
                </div>
            )}

            {isLoadingArticles && (
                <div className="mt-12 h-80 w-full">
                    <div className="mx-auto">
                        <CircleSpinner className="w-5 h-5" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewsSection;
